<template>
  <DxTabPanel>
    <DxItem title="Reporte XSXL" template="dashboar-report-xlsx-tab" />
    <template #dashboar-report-xlsx-tab>
      <DownloadReportXslx />
    </template>

    <!-- <DxItem title="Dashboard" template="dashboar-report-tab" />
    <template #dashboar-report-tab>
      <DashboardReport />
    </template> -->
  </DxTabPanel>
</template>

<script>
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
// import DashboardReport from "./utils/DashboardReport.vue";
import DownloadReportXslx from "./utils/DownloadReportXslx.vue";

export default {
  components: {
    DxTabPanel,
    DxItem,
    // DashboardReport,
    DownloadReportXslx,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
